import { render } from "./PcSubmenuList.vue?vue&type=template&id=00638b45&ts=true"
import script from "./PcSubmenuList.vue?vue&type=script&lang=ts"
export * from "./PcSubmenuList.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__